// Thai public holidays 2025–2026 (same set as TestRunTab working-day calc)
export const THAI_HOLIDAY_NAMES = {
  "2025-01-01": "วันขึ้นปีใหม่",
  "2025-02-12": "วันมาฆบูชา",
  "2025-04-06": "วันจักรี",
  "2025-04-07": "ชดเชยวันจักรี",
  "2025-04-14": "วันสงกรานต์",
  "2025-04-15": "วันสงกรานต์",
  "2025-04-16": "วันสงกรานต์",
  "2025-05-01": "วันแรงงานแห่งชาติ",
  "2025-05-12": "วันวิสาขบูชา",
  "2025-06-03": "วันเฉลิมพระชนมพรรษาสมเด็จพระนางเจ้าสุทิดา",
  "2025-07-11": "วันอาสาฬหบูชา",
  "2025-07-28": "วันเฉลิมพระชนมพรรษา ร.10",
  "2025-08-12": "วันแม่แห่งชาติ",
  "2025-10-13": "วันคล้ายวันสวรรคต ร.9",
  "2025-10-23": "วันปิยมหาราช",
  "2025-12-05": "วันพ่อแห่งชาติ",
  "2025-12-10": "วันรัฐธรรมนูญ",
  "2025-12-31": "วันสิ้นปี",
  "2026-01-01": "วันขึ้นปีใหม่",
  "2026-03-04": "วันมาฆบูชา",
  "2026-04-06": "วันจักรี",
  "2026-04-13": "วันสงกรานต์",
  "2026-04-14": "วันสงกรานต์",
  "2026-04-15": "วันสงกรานต์",
  "2026-05-01": "วันแรงงานแห่งชาติ",
  "2026-05-22": "วันวิสาขบูชา",
  "2026-06-03": "วันเฉลิมพระชนมพรรษาสมเด็จพระนางเจ้าสุทิดา",
  "2026-07-08": "วันอาสาฬหบูชา",
  "2026-07-28": "วันเฉลิมพระชนมพรรษา ร.10",
  "2026-08-12": "วันแม่แห่งชาติ",
  "2026-10-13": "วันคล้ายวันสวรรคต ร.9",
  "2026-10-23": "วันปิยมหาราช",
  "2026-12-05": "วันพ่อแห่งชาติ",
  "2026-12-10": "วันรัฐธรรมนูญ",
  "2026-12-31": "วันสิ้นปี",
};

export const THAI_HOLIDAYS = new Set(Object.keys(THAI_HOLIDAY_NAMES));

export function toDateKey(date) {
  if (!date) return "";
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function isThaiPublicHoliday(date) {
  const key = toDateKey(date);
  return key ? THAI_HOLIDAYS.has(key) : false;
}

export function getThaiHolidayName(date) {
  const key = toDateKey(date);
  return key ? THAI_HOLIDAY_NAMES[key] || "" : "";
}
